import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { SUBSCRIPTION_ERROR_MESSAGE } from "../../../api/api";


const VALID_SUBSCRIPTION_CODES = ["402", "403", "406"] as const;
type IValidSubscriptionCode = typeof VALID_SUBSCRIPTION_CODES[number];
export type ISubscriptionCode = {
    code: number,
    message: string
} | null;

export const useSubscriptionError = (): ISubscriptionCode => {
    const [searchParams] = useSearchParams();

    return useMemo(() => {
    const code = searchParams.get("code") as IValidSubscriptionCode | null;
    const customMessage = searchParams.get("message");

    if (!code || !VALID_SUBSCRIPTION_CODES.includes(code)) return null;

    // Use custom message from URL if provided, otherwise fall back to default message
    const message = customMessage 
      ? decodeURIComponent(customMessage) 
      : SUBSCRIPTION_ERROR_MESSAGE[code];

    return {
      code: Number(code),
      message,
    };
  }, [searchParams]);
};